import React, { useState } from "react";
import styles from "./TransferStudentModal.module.css";
import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import OnlyDropDown from "../../components/OnlyDropDown/OnlyDropDown";
import { MdTransferWithinAStation } from "react-icons/md";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice"; // or your modal slice

const TransferStudentModal = () => {
  const dispatch = useDispatch();

  const [branch, setBranch] = useState("");
  const [room, setRoom] = useState("");
  const [status, setStatus] = useState("");
  const [copyAdmission, setCopyAdmission] = useState(false);

  const branchOptions = ["Branch A", "Branch B", "Branch C"];
  const roomOptions = ["Room 1", "Room 2", "Room 3"];
  const statusOptions = ["Active", "Transferred", "Withdrawn"];

  const handleCancel = () => {
    console.log("Transfer modal closed");
    dispatch(closeModal());
  };

  const handleTransfer = () => {
    if (!branch || !room || !status) {
      alert("Please select all fields");
      return;
    }

    const data = {
      branch,
      room,
      status,
      copyAdmission,
    };

    console.log("Submitted Transfer Data:", data);
    // Here you can also dispatch an action: dispatch(transferStudent(data));
    dispatch(closeModal());
  };

  return (
    <div className={styles.modalWrapper}>
      <div className={styles.modalContainer}>
        <div className={styles.modalHeader}>
          <HeadingAndIcon
            icon={<MdTransferWithinAStation  color="white" />}
            heading="Transfer Students to new center"
          />
        </div>

        <div className={styles.modalBody}>
          <OnlyDropDown
            label="Branch"
            name="branch"
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
            options={branchOptions}
            required
          />
          <OnlyDropDown
            label="Room"
            name="room"
            value={room}
            onChange={(e) => setRoom(e.target.value)}
            options={roomOptions}
            required
          />
          <OnlyDropDown
            label="Set Status"
            name="status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            options={statusOptions}
            required
          />
          <div className={styles.checkboxContainer}>
            <input
              type="checkbox"
              id="copyAdmission"
              checked={copyAdmission}
              onChange={(e) => setCopyAdmission(e.target.checked)}
            />
            <label htmlFor="copyAdmission">Copy Admission number</label>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <SaveAndCancel
            onCancel={handleCancel}
            onSave={handleTransfer}
            cancelLabel="Cancel"
            saveLabel="Transfer"
          />
        </div>
      </div>
    </div>
  );
};

export default TransferStudentModal;
